import { CommonModule, formatDate } from "@angular/common";
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, NO_ERRORS_SCHEMA, ViewChildren, QueryList } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModalOptions, NgbModule, NgbAccordion, NgbAccordionConfig } from "@ng-bootstrap/ng-bootstrap";
import { ModalOptions } from "ngx-bootstrap/modal";
import { BehaviorSubject, Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { GigsumoConstants, USER_TYPE } from "src/app/services/GigsumoConstants";
import { GigsumoService, pauseForSeconds } from "src/app/services/gigsumoService";
import { JobService, updateStatusCheckBox } from "src/app/services/job.service";
import { JobModel } from 'src/app/services/jobModel';
import { UtilService } from 'src/app/services/util.service';
import { CustomerFilterTemplateComponent } from '../../bussinesspages/user-management/customer-filter-template/customer-filter-template.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NgIconComponent } from '@ng-icons/core';

@Component({
  selector: 'app-job-filter-vertical-template',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgbModule, CustomerFilterTemplateComponent, CommonSkeletonComponent, NgIconComponent],
  schemas: [NO_ERRORS_SCHEMA],
  // Component-local NgbAccordionConfig: every accordion in this template
  // (and in the nested app-customer-filter-template sections, which resolve
  // the config from this element injector) opens/closes WITHOUT the ngb
  // collapse animation. The animation relies on Bootstrap 5's .collapsing
  // CSS; this app ships Bootstrap 3, so the engine just waited out the
  // ~350ms transition with nothing visibly animating — a dead delay on
  // every toggle. Accordions elsewhere in the app are unaffected.
  providers: [NgbAccordionConfig],
  templateUrl: './job-filter-vertical-template.component.html',
  styleUrls: ['./job-filter-vertical-template.component.scss']
})
export class JobFilterVerticalTemplateComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() viewType: any;
  @Input() filterChanges: any;
  @Input('resetFilter') clearFilter: boolean;
  // When true, the Job Source accordion section is hidden. Used by SuperAdmin
  // org-scoped views (e.g. customer-business-joblist) where lane/source flags
  // (My Jobs / B2B / etc.) don't apply.
  @Input() hideJobSource: boolean = false;
  // When true, the Job Source accordion shows ONLY "My Jobs" + "My Employees"
  // (used by /jobs/findOrgJobs SuperAdmin view). All other source checkboxes
  // and sub-lists (Marketplace, Workspace, Member/Business Network, Customer,
  // Published By, Sub-Contracting, personal networks) are hidden.
  @Input() orgJobsMode: boolean = false;
  // Pre-fetched employee list (e.g. from subscription/findEmployeeBenefitsAllocation).
  // Each item must expose `userId` and `fullName`. Drives the picker that opens
  // when the "My Employees" checkbox is checked in orgJobsMode.
  @Input() employeeListInput: any[] = [];
  // Parent owns the paginated employee fetch (so it can keep the Transfer modal's
  // userList separate). We bubble the picker's debounced search + scroll up here.
  @Output() employeeSearch = new EventEmitter<string>();
  @Output() employeeScroll = new EventEmitter<void>();
  // Fires when SuperAdmin toggles "My Employees" ON. Parent listens and
  // lazily calls findEmployeeList — avoids the prefetch on every page open.
  @Output() myEmployeesToggled = new EventEmitter<void>();
  // Parent-owned loading flag — true while findEmployeeList is in flight.
  // Bound directly to the My Employees picker's [isLoading] so the spinner
  // is driven by the actual API call lifecycle, not by the data input
  // (which can be transiently empty during a reset).
  @Input() employeeLoadingInput: boolean = false;

  // Locally-owned flags for the OFF transition of "My Employees". When
  // the user unticks the checkbox, *ngIf would otherwise hide the picker
  // immediately. We hold it open for ~600ms while showing the spinner
  // so the off-toggle gets the same visual feedback as on-toggle, then
  // unmount. Re-ticking ON within that window cancels the timer so the
  // picker stays mounted continuously without a flash.
  employeeOffShowing: boolean = false;
  employeeOffLoading: boolean = false;
  private employeeOffTimer: any = null;
  ischeckedStatusAll: boolean = false
  totalCount
  validTotalPoints: boolean
  deactivatedJobs: Array<JobModel> = [];
  filterApplied: boolean = false
  searchContent: any;
  keyarrayjobsouces = JobService.FILTER_ELEMENT;
  keyarrayClientType = ["directHire", "systemsIntegrator", "staffingAgency", "primeVendor", "vendor"];
  keysarrWorks = ["All", "Onsite", "Remote", "Hybrid"];
  userType: any = localStorage.getItem('userType')
  userIdStorage = localStorage.getItem('userId')
  jobFoundStatus: any = "Fetching Jobs..."
  activeStatus: boolean = null;
  ischeckedJobClassification: boolean = false
  ischeckedJobClassificationAll: boolean = false
  listingCount = 0;
  jobSource: any = [];
  value: number = 0;
  filterData: any;
  networkflag: boolean = false;
  jobSourceSelectNetRoute: any
  searchUserType: any
  totalmsgcounts: any;
  totalmsgcount: Subscription;
  ScreenLoadBool: boolean = false
  jobSourceSearchRoute = null
  queryParamValues: any;
  highValue: number = 0;
  options: any = {
    ceil: 20,
    floor: 0
  };
  data: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }


  value1: number = 0;
  highValue1: number = 0;
  options1: any = {
    floor: 0,
    ceil: 99
  };
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    jobPostedBy: localStorage.getItem('userId')
  }
  jobFilterForm: UntypedFormGroup
  stopscrollFlag: boolean = false
  owner: boolean = false
  data1: any = {}
  connectionJobs: boolean = false;
  previousSearchAfterKey = null;
  ischeckedStatus: boolean = false
  previousSearchAfterKey1 = null;
  clientTypeCheckboxes = [
    { label: 'All', selected: false, disable: false },
    // { label: 'Direct Client', selected: false, disable: false },
    { label: 'Client', selected: false, disable: false },
    // { label: 'Direct Hire', selected: false, disable: false },
    { label: 'Systems Integrator', selected: false, disable: false },
    { label: 'Staffing Agency', selected: false, disable: false },
    { label: 'Prime Vendor', selected: false, disable: false },
    // { label: 'Vendor', selected: false, disable: false },
    // { label: 'Supplier', selected: false, disable: false },
  ];
  workModeCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Onsite', selected: false, disable: false },
    { label: 'Remote', selected: false, disable: false },
    { label: 'Hybrid', selected: false, disable: false },
  ];

  statusCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Draft', selected: false, disable: false },
    { label: 'Active', selected: false, disable: false },
    { label: 'On Hold', selected: false, disable: false },
    { label: 'Filled', selected: false, disable: false },
    // { label: 'Closed', selected: false, disable: false },
    // { label: 'Inactive', selected: false, disable: false },

  ];

  jobclasscificationCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Corp To Corp', selected: false, disable: false },
    { label: 'W2 - Contract', selected: false, disable: false },
    { label: 'W2 - Full Time', selected: false, disable: false },
    { label: 'Part Time', selected: false, disable: false },
    { label: 'Freelance', selected: false, disable: false },
    { label: 'Internship', selected: false, disable: false },
    { label: 'Contract to Hire', selected: false, disable: false },
    { label: 'Direct Hire', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false },
  ];
  filterOn: boolean = false
  response: any = [];
  ischeckedClientType: boolean = false
  ischeckedClientTypeAll: boolean = false
  triggerapi = new BehaviorSubject("null")
  getResume: boolean = false
  creditexpiredflag: boolean = false
  availablePoints
  sendProfileData
  receiveFilterData: Subscription;
  resetFilter: Subscription;
  isMyJobsShowedOnLoad: boolean = false;
  @Input() jobFilterData: any;
  @Input() businessId: any;
  recruiterNetwork: boolean = false;
  freelancerNetwork: boolean = false;
  benchNetwork: boolean = false;
  mtaNetwork: boolean = false;
  jobseekerNetwork: boolean = false;
  personalNetworks: Array<any> = [];
  memberNetworks: Array<any> = [];
  businessNetworkData: Array<any> = [];
  publishedPayload = {
    memberNetworkChosen : false,
    all : false,
    personalNetworks : [],
    users : [],
    type : "JOB",
    userId : null ,
    searchContent: null,
    searchAfterKey: null,
    limit: 10
  }
  customerPayload = {
    businessId: null,
    memberNetworkChosen : false,
    businessNetworkChosen : false,
    subContractingChosen : false,
    businessNetworks: [],
    businessList: [],
    searchContent:null,
    searchAfterKey : null,
    userId : null,
    limit: 10
  }
  jobFilterFormData: any;
  publishedByStopScroll: boolean = false;
  customersStopScroll: boolean = false;
  publishedByPrevSearchAfterKey: any;
  customersPrevSearchAfterKey: any;
  tempBusinessNetworks: any[];
  istempBusinessNetwork: boolean = false;
  membershipType = localStorage.getItem('MemberShipType');
  memberAvailable : boolean = false;


  constructor(private formBuilder: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private util: UtilService,
     private apiService: ApiService, private jobService: JobService, private gigsumoService: GigsumoService,
     accordionConfig: NgbAccordionConfig, ) {
    accordionConfig.animation = false;
    this.memberAvailable = (this.userType === 'JOB_SEEKER' || this.membershipType === 'Free' || this.membershipType === 'Pro');
    this.userType = localStorage.getItem('userType');
    this.createjobFilterForm();
    this.getJobSourceData();
    this.receiveFilterData = this.jobService.getDataForFilter().subscribe(data => {
      if (data) {
        this.removeEntity(data.value, data.index);
      }
    });

    // SuperAdmin org-jobs page: slider footer Reset emits setSliderToggle with
    // reset=true. Parent's onFilterToggle('reset') only clears the API payload,
    // not the template's local UI state — so the checkbox arrays / sliders /
    // form / employee picker stay populated, and re-clicking the same checkbox
    // toggles it OFF instead of applying the same filter. Gated to orgJobsMode
    // so the reference /jobs/filter flow (new-job.component) is untouched.
    this.resetFilter = this.jobService.getSliderToggle().subscribe(value => {
      if (value?.reset === true && this.orgJobsMode) {
        this.resetOrgJobsFilterUiState();
      }
      // Brief loader on All Filter open. The slide-out is already host
      // mounted; nothing actually re-fetches, so we just flip isLoading
      // for ~500ms so the existing <app-common-skeleton 'verticalCheckboxSelection'>
      // renders the same 47px purple circle the regular Job module shows.
      if (value?.value === true && this.orgJobsMode) {
        this.isLoading = true;
        setTimeout(() => { this.isLoading = false; }, 500);
      }
    });



    this.activatedRoute.queryParams.subscribe(params => {
      if (params.networkName && params.networkName == 'MANAGEMENT_TALENT_ACQUISITION_NETWORK') {
        this.mtaNetwork = true
        this.freelancerNetwork = false
        this.recruiterNetwork = false
        this.jobseekerNetwork = false
        this.benchNetwork = false
      } else if (params.networkName && params.networkName == 'FREELANCE_RECRUITER_NETWORK') {
        this.mtaNetwork = false
        this.freelancerNetwork = true
        this.recruiterNetwork = false
        this.jobseekerNetwork = false
        this.benchNetwork = false
      } else if (params.networkName && params.networkName == 'JOB_SEEKER_NETWORK') {
        this.mtaNetwork = false
        this.freelancerNetwork = false
        this.recruiterNetwork = false
        this.jobseekerNetwork = true
        this.benchNetwork = false
      } else if (params.networkName && params.networkName == 'RECRUITER_NETWORK') {
        this.mtaNetwork = false
        this.freelancerNetwork = false
        this.recruiterNetwork = true
        this.jobseekerNetwork = false
        this.benchNetwork = false
      }
    })

  }

  ngOnDestroy(): void {
    this.resetFilter?.unsubscribe();
  }

  // SuperAdmin-only reset. Mirrors the field-by-field clear that
  // new-job.component.resetFilternew() performs on the reference page, but
  // scoped to the state the SuperAdmin filter slider actually exposes.
  // Called from the getSliderToggle subscription above when the slider-footer
  // All the filter section accordions in this template (Source, Status,
  // Client Type, Engagement, Work Mode, Location, Experience, Posted
  // Days). @ViewChildren does NOT cross into the child picker components,
  // so this captures only the 8 top-level sections — used to collapse
  // them back to the page-load default on Reset.
  @ViewChildren(NgbAccordion) filterAccordions: QueryList<NgbAccordion>;

  // Collapse every filter accordion, then re-expand Source (custom-panel-1,
  // the first accordion) so the slider matches its page-load default after
  // a Reset. Scoped to orgJobsMode (Job Center) only.
  private resetAccordionsToDefault() {
    if (!this.orgJobsMode || !this.filterAccordions) return;
    this.filterAccordions.forEach(acc => acc.collapseAll());
    const sourceAccordion = this.filterAccordions.first;
    if (sourceAccordion) sourceAccordion.expand('custom-panel-1');
  }

  // Reset button fires reset=true, AND directly by the parent header Reset
  // (customer-business-joblist.onResetFilters()) so both reset paths clear
  // the same fields. Exposed as public for the @ViewChild call.
  resetOrgJobsFilterUiState() {
    // Status defaults to ALL checked on SuperAdmin Job Center (matches
    // the page-load pre-tick), so reset should restore that — not wipe
    // it. Other group-checkboxes (client / work mode / engagement) reset
    // to fully unchecked since they have no SuperAdmin pre-tick.
    this.statusCheckboxes.forEach(item => { item.selected = this.orgJobsMode; item.disable = false; });
    this.clientTypeCheckboxes.forEach(item => { item.selected = false; item.disable = false; });
    this.workModeCheckboxes.forEach(item => { item.selected = false; item.disable = false; });
    this.jobclasscificationCheckboxes.forEach(item => { item.selected = false; item.disable = false; });

    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;

    if (this.jobFilterForm) {
      this.jobFilterForm.patchValue({
        city: null,
        state: null,
        country: null,
        zipCode: null,
        experienceFrom: null,
        experienceTo: null,
        postedFrom: null,
        postedTo: null,
        experienceType: 'Any (Years)',
        // Must match GigsumoConstants.POSTED_ANY ("Any (Days)") so the
        // "Any" radio renders selected by default AND getPostedDaysCount()
        // returns 0 (the previous "Any (Posted Day)" string didn't match
        // either, leaving no radio selected and the count badge stuck at 1).
        postedDayRange: GigsumoConstants.POSTED_ANY,
      });
    }

    this.selectedEmployees = [];
    // Also clear the picker-side selection state. Without this, the
    // BehaviorSubject still holds items with enabled=true from any
    // previously picked employees, so the checkboxes inside the picker
    // stay visually ticked even after Reset. Clears the prev-selected
    // cache AND walks the current BehaviorSubject value to flip every
    // item's enabled flag back to false.
    this.employeePrevSelectedValue = [];
    const currentEmployees = this.employeeList.getValue();
    if (currentEmployees && currentEmployees.length > 0) {
      this.employeeList.next(currentEmployees.map(item => ({ ...item, enabled: false })));
    }

    // Clear the picker's search-box text (e.g. user typed "wal" then
    // hit Reset — the input must go back to empty). The picker's
    // own ngOnChanges blanks searchValue when [resetFilter] flips to
    // true, so we toggle the form-bound flag true → false here.
    if (this.jobFilterForm) {
      this.jobFilterForm.get('resetFilter')?.patchValue(true);
      setTimeout(() => this.jobFilterForm.get('resetFilter')?.patchValue(false), 0);
    }

    if (this.jobSourcesFormarray?.at(0)) {
      this.jobsouceCheckedAll(false);
      // After the cascade clear, restore the SuperAdmin defaults so the
      // page-load pre-tick of "My Jobs" + "My Employees" is preserved
      // across a Reset (matches the Experience / Posted Days behaviour
      // where their "Any" defaults survive reset).
      if (this.orgJobsMode && !this.hideJobSource) {
        const src = this.jobSourcesFormarray.at(0);
        src.get('myJobs')?.patchValue(true);
        src.get('myEmployees')?.patchValue(true);
      }
    }

    // Collapse expanded accordions back to the page-load default
    // (Source open, rest closed). setTimeout(0) lets the reset's
    // form/checkbox writes settle first so the collapse isn't undone
    // by a re-render in the same change-detection tick.
    setTimeout(() => this.resetAccordionsToDefault(), 0);
  }

  // recieve filter data from new-job component
  ngOnChanges(changes: SimpleChanges): void {

    this.publishedPayload.userId = localStorage.getItem('userId');
    this.customerPayload.userId = localStorage.getItem('userId');
    this.customerPayload.businessId = localStorage.getItem('businessId');
    this.updateJobFilterData();

    if (changes.employeeListInput) {
      const list = changes.employeeListInput.currentValue || [];
      // Keep previously-ticked employees visible+enabled across paginated
      // re-fetches and server-side searches (mirror publishedByPrevSelectedValue
      // pattern). Without this, applying a search would drop selected ticks.
      const stillSelected = (this.employeePrevSelectedValue || [])
        .filter(s => this.selectedEmployees.includes(s.userId))
        .map(s => ({ ...s, enabled: true }));
      const selectedIds = new Set(stillSelected.map(s => s.userId));
      const incoming = list
        .filter(u => !selectedIds.has(u.userId))
        .map(u => ({ ...u, enabled: this.selectedEmployees.includes(u.userId) }));
      this.employeeList.next([...stillSelected, ...incoming]);
      // Parent owns the fetch, so we clear the loading flag here once the new
      // input has been pushed to the picker. customer-filter-template sets
      // superObj.isLoading=true on search/scroll and we have no other signal
      // back; this avoids the picker being stuck in the loading skeleton.
      this.isLoading = false;
    }


    if (changes.filterChanges !== undefined && changes.filterChanges.currentValue != undefined) {
      let data: any = changes.filterChanges.currentValue;

      // job source reset filter
      if(data.formData.resetFilter === true && this.jobSourcesFormarray.at(0) != undefined){
        this.resetFilterDefault();
        this.jobFilterForm.patchValue(data.formData);
      }
      else{


        this.jobFilterForm.patchValue(data.formData);
        this.jobFilterFormData = data.formData;
        this.jobSource = data.checkedItems;
        this.clientTypeCheckboxes = data.clientTypeCheckedItems === undefined ? this.clientTypeCheckboxes : data.clientTypeCheckedItems;
        this.statusCheckboxes = data.statusCheckedItems === undefined ? this.statusCheckboxes : data.statusCheckedItems;
        this.workModeCheckboxes = data.workMode === undefined ? this.workModeCheckboxes : data.workMode;
        this.jobclasscificationCheckboxes = data.jobClassifications === undefined ? this.jobclasscificationCheckboxes : data.jobClassifications;
        this.value1 = data.formData.postedFrom != null ? data.formData.postedFrom : 0;
        this.highValue1 = data.formData.postedTo != null ? data.formData.postedTo : 0;
        this.value = data.formData.experienceFrom != null ? data.formData.experienceFrom : 0;
        this.highValue = data.formData.experienceTo != null ? data.formData.experienceTo : 0;


        const isMyJobsChecked : boolean  =  data.formData.source[0].myJobs;
        // orgJobsMode (SuperAdmin org-scoped view) sees Drafts across the
        // entire org regardless of which Job-Source sub-option is ticked,
        // so the Draft status checkbox must stay enabled.
        this.statusCheckboxes = updateStatusCheckBox(data.statusCheckedItems , this.orgJobsMode || (this.owner ?  isMyJobsChecked : false) , false);

        // let customerSelected = data.customerSelectedData === undefined ? [] : data.customerSelectedData;
        // let publishedSelected = data.publishedSelectedData === undefined ? [] : data.publishedSelectedData;

        data.businessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;
        data.personalNetworks = data.personalNetworks === undefined ? [] : data.personalNetworks;

        // busniess network Interaction
        if (data.formData.source[0].businessNetwork != this.istempBusinessNetwork ||
          JSON.stringify(data.businessNetworks) != JSON.stringify(this.customerPayload.businessNetworks)
          ) {

          this.setToDefaulFilter("CUSTOMER");
          this.istempBusinessNetwork = data.formData.source[0].businessNetwork;
          this.customerPayload.businessNetworkChosen = data.formData.source[0].businessNetwork
          this.customerPayload.businessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;
          this.selectedBusinessNetworks = this.istempBusinessNetwork ? (data.businessNetworks === undefined ? [] : data.businessNetworks) : [];
          this.customerPayload.businessList = this.customerPrevSelectedValue.map(x=>x.businessId);;

          this.getBusinessCustomers();
        }

        // member network interaction
        if( data.formData.source[0].memberNetworksJobs != this.customerPayload.memberNetworkChosen ){
          this.setToDefaulFilter("CUSTOMER");
          this.customerPayload.memberNetworkChosen = data.formData.source[0].memberNetworksJobs;
          this.getBusinessCustomers("MEMBER_NETWORK");
        }

        // sub-contracting interaction
        if (data.formData.source[0].eligibleSubContractJobs != this.customerPayload.subContractingChosen) {
          this.setToDefaulFilter("CUSTOMER");
          this.customerPayload.subContractingChosen = data.formData.source[0].eligibleSubContractJobs;
          if (this.customerPayload.subContractingChosen) {
            this.customerPayload.memberNetworkChosen = false;
            this.customerPayload.businessNetworkChosen = false;
          }
          this.getBusinessCustomers();
        }

        // personal network Interaction
        if (JSON.stringify(data.personalNetworks) != JSON.stringify(this.publishedPayload.personalNetworks)) {
          this.setToDefaulFilter();
          this.publishedPayload.memberNetworkChosen = data.formData.source[0].memberNetworksJobs;
          this.publishedPayload.personalNetworks = data.personalNetworks === undefined ? [] : data.personalNetworks;
          this.publishedPayload.users = this.publishedByPrevSelectedValue.map(x=>x.userId);
          this.getPublishedBy();
        }

        // this.customerPrevSelectedValue = customerSelected;
        // this.publishedByPrevSelectedValue =  publishedSelected;
        // this.businessNetworkPrevSelectedValue =  data.businessNetworkSelectedData === undefined ? [] : data.businessNetworkSelectedData;


        // if (this.businessNetworkPrevSelectedValue.length > 0) {
        //   setTimeout(() => {
        //     this.businessNetworkData = this.businessNetworkPrevSelectedValue;
        //   }, 1000);
        // }

      }


      // const isMyJobsChecked : boolean  = this.jobSourcesFormarray.at(0) != undefined ? this.jobSourcesFormarray.at(0).get('myJobs').value : false;
      // this.statusCheckboxes = updateStatusCheckBox(data.statusCheckedItems , isMyJobsChecked);

    }


  }
  workModeChange(checked, label) {
    if (label === 'All') {

      if (checked) {
        this.workModeCheckboxes.forEach(item => item.selected = true);
      }
      else if (!checked) {
        this.workModeCheckboxes.forEach(item => item.selected = false);
      }
    }
    else if (label != 'All') {

      this.workModeCheckboxes.forEach(item => {
        if (item.label === label) {
          item.selected = checked;
        }
      });

      const isAllchecked = this.workModeCheckboxes.filter(val => val.label != 'All').every(item => item.selected === true);
      this.workModeCheckboxes[0].selected = isAllchecked;

    }
    this.updateFunction();
  }

  resetFilterDefault(){
    this.jobsouceCheckedAll(false);
    this.publishedPayload.personalNetworks = [];
    this.customerPayload.businessNetworks = [];
    this.publishedPayload.searchContent = "";
    this.customerPayload.searchContent = "";
    this.selectedBusinessNetworks = [];
    this.selectedPublishedBy = [];
    this.selectedCustomers = [];
    this.businessNetworkData =  this.tempBusinessNetworks;
    this.customerPrevSelectedValue = [];
    this.publishedByPrevSelectedValue = [];
    this.businessNetworkPrevSelectedValue = [];
    this.setToDefaulFilter();
    this.setToDefaulFilter("CUSTOMER");
    this.getPublishedBy();
    this.getBusinessCustomers();
}

  ngAfterViewInit(): void {
    if (this.mtaNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceJobs').patchValue(false);
      this.jobSourcesFormarray.at(0).get('mtaNetworkJobs').patchValue(true);
    } else if (this.freelancerNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceJobs').patchValue(false);
      this.jobSourcesFormarray.at(0).get('freeLancerNetworkJobs').patchValue(true);
    } else if (this.jobseekerNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceJobs').patchValue(true);
    } else if (this.recruiterNetwork) {
      this.jobSourcesFormarray.at(0).get('marketPlaceJobs').patchValue(false);
      this.jobSourcesFormarray.at(0).get('recruiterNetworkJobs').patchValue(true);
    }


  }

  @Input() valuesSentForFilters: any;
  lablechangeclienttype: string = '';
  EXPERIENCE_ANY = GigsumoConstants.EXPERIENCE_ANY;
  EXPERIENCE_JUNIOR = GigsumoConstants.EXPERIENCE_JUNIOR;
  EXPERIENCE_MID_LEVEL = GigsumoConstants.EXPERIENCE_MID_LEVEL;
  EXPERIENCE_SENIOR = GigsumoConstants.EXPERIENCE_SENIOR;
  EXPERIENCE_ARCHITECT = GigsumoConstants.EXPERIENCE_ARCHITECT;

  POSTED_ANY = GigsumoConstants.POSTED_ANY;
  POSTED_TODAY = GigsumoConstants.POSTED_TODAY;
  POSTED_LAST_7_DAYS = GigsumoConstants.POSTED_LAST_7_DAYS;
  POSTED_LAST_14_DAYS = GigsumoConstants.POSTED_LAST_14_DAYS;
  POSTED_LAST_30_DAYS = GigsumoConstants.POSTED_LAST_30_DAYS;

  ngOnInit() {
    this.getCountries();
  }

  getJobSourceData() {

    // Full-panel overlay while the filter opens and its structural data loads.
    // Cleared once the Source data is in and the dropdown fetches are kicked
    // off — from then on each dropdown shows its own scoped spinner.
    this.isLoading = true;
    this.gigsumoService.getFilterELement("JOB", this.userIdStorage).subscribe(async response => {
      if (response.code === GigsumoConstants.SUCESSCODE) {

        this.businessNetworkData = response.data.businessNetworks;
        this.tempBusinessNetworks = this.businessNetworkData;
        this.memberNetworks = response.data.memberNetworks;
        this.personalNetworks = response.data.personalNetworks.map(r => {
          let data = GigsumoService.FILTER_ITEMS().find(x => x.value === r.networkName);
          if (data) {
            r.key = data.key;
          }
          else {
            r.key = r.networkId;
          }
          return r;
        });
        this.jobsoucefilterFrom(this.personalNetworks);

        // SuperAdmin Job Center: pre-tick "My Jobs" and "My Employees"
        // so the filter slider opens with these defaults visible.
        // Listing API isn't auto-applied — user clicks Apply to filter.
        // The myEmployees emit kicks off the picker's employee fetch
        // so the dropdown is populated when the user expands it.
        if (this.orgJobsMode && !this.hideJobSource) {
          const src = this.jobSourcesFormarray.at(0);
          if (src) {
            src.get('myJobs')?.patchValue(true);
            src.get('myEmployees')?.patchValue(true);
            this.myEmployeesToggled.emit();
          }
        }

        // SuperAdmin Job Center: pre-tick every Status checkbox (All,
        // Draft, Active, On Hold, Filled) so the listing isn't restricted
        // by status out of the box. Matches the pre-tick treatment of
        // "My Jobs" + "My Employees" above.
        if (this.orgJobsMode) {
          this.statusCheckboxes.forEach(item => { item.selected = true; item.disable = false; });
        }

        this.getPublishedBy();

        if((this.businessNetworkData || this.memberAvailable)){
          this.customerPayload.businessNetworks = [];
          this.customerPayload.businessId = localStorage.getItem("businessId");
          await pauseForSeconds(500);
          this.setToDefaulFilter("CUSTOMER");
          this.getBusinessCustomers(this.memberAvailable ? "MEMBER_NETWORK" : "BUSINESS-NETWORK");
        }
        // Structural load done + dropdown fetches kicked off; drop the overlay
        // so the per-dropdown spinners take over.
        this.isLoading = false;
      }
      else{
        this.isLoading = false;
      }

    }, () => {
      this.isLoading = false;
    });

  }


  publishedByList = new BehaviorSubject<any[]>([]);
  getPublishedBy() {
      this.publishedByLoading = true;
      this.publishedPayload.all = this.jobSourcesFormarray.at(0)!=undefined && this.jobSourcesFormarray.at(0).get('all').value;
      this.apiService.create("business/findNetworkConnections", this.publishedPayload).subscribe(response=>{
          this.publishedByLoading = false;
          console.log("This" , this);
          if(response.code === GigsumoConstants.SUCESSCODE){
            const users = response.data.connectionsList;
            const searchKey = response.data.searchAfterKey;

            if (users) {
              const current = users;
              const exist = this.publishedByList.getValue();
              if(this.publishedByPrevSelectedValue && this.publishedByPrevSelectedValue.length > 0){
                const retainUser = response.data.usersToRetain;
                if(retainUser === undefined){
                  this.publishedByPrevSelectedValue = [];
                }
                else if(retainUser){
                  this.publishedByPrevSelectedValue = this.publishedByPrevSelectedValue.filter(x => retainUser.includes(x.userId));
                }

                this.selectedPublishedBy = this.publishedByPrevSelectedValue.map(x => x.userId);
                this.updateFunction();
              }
              let data = (this.publishedByPrevSelectedValue &&
                         this.publishedByPrevSelectedValue.length > 0) ? exist.concat(this.publishedByPrevSelectedValue)
                         : exist;
              let finalData = this.gigsumoService.removeDuplicatesKey([...data, ...current] , 'userId');
               this.publishedByList.next(finalData);
            }

          if (
            users != null && (users.length === 0 || JSON.stringify(this.publishedByPrevSearchAfterKey) === JSON.stringify(searchKey))
          ) {
            this.publishedByStopScroll = true;
          }

            this.publishedByPrevSearchAfterKey = searchKey;

          }

      }, () => {
          this.publishedByLoading = false;
      });

  }

  customersList = new BehaviorSubject<any[]>([]);
  // isLoading drives the full-panel overlay: shown while the filter first
  // opens AND while a Business Network pick reloads. Per-dropdown open/search
  // use the scoped flags below; scroll pagination uses the *More flag.
  isLoading: boolean = false
  publishedByLoading: boolean = false
  customerLoading: boolean = false
  // Scroll pagination loader. Separate from customerLoading (which replaces
  // the list with a spinner and resets scroll to the top); loadingMore shows a
  // bottom spinner while the loaded rows stay put.
  customerLoadingMore: boolean = false
  async getBusinessCustomers(from : string = "BUSINESS-NETWORK", mode : 'replace' | 'scroll' | 'global' = 'replace') {

    if((this.membershipType == "Growth" || this.membershipType == "Starter"||this.membershipType == "ScaleX") || from === 'MEMBER_NETWORK' ){
      // global  = Business Network pick → full-panel overlay.
      // scroll  = pagination → bottom spinner, list stays put.
      // replace = open/search → full-body spinner in the Customer dropdown.
      if(mode === 'global'){ this.isLoading = true; }
      else if(mode === 'scroll'){ this.customerLoadingMore = true; }
      else { this.customerLoading = true; }
      this.customerPayload.businessId = this.businessId;
      this.apiService.create("business/findBusinessCustomers", this.customerPayload).subscribe(response=>{
        if(response.code === GigsumoConstants.SUCESSCODE){

          const users = response.data.businessDetails;
          const searchKey = response.data.searchAfterKey;

          if (users) {
            const current = users;
            const exist = this.customersList.getValue();
            if(this.customerPrevSelectedValue && this.customerPrevSelectedValue.length > 0){
              const retainUser = response.data.businessesToRetain;
              if(retainUser === undefined){
                this.customerPrevSelectedValue = [];
              }
              else if(retainUser){
                this.customerPrevSelectedValue = this.customerPrevSelectedValue.filter(x => retainUser.includes(x.businessId));
              }
              this.selectedCustomers = this.customerPrevSelectedValue.map(x=> x.businessId);
              this.updateFunction();
            }
            let data = (this.customerPrevSelectedValue  &&
            this.customerPrevSelectedValue.length > 0) ? exist.concat(this.customerPrevSelectedValue)
            : exist;
            let finalData = this.gigsumoService.removeDuplicatesKey([...data, ...current] , 'businessId');

            this.customersList.next(finalData);
          }

          if (
            users != null && (users.length === 0 || JSON.stringify(this.customersPrevSearchAfterKey) === JSON.stringify(searchKey))
          ) {
            console.log("scroll happeni",this.customersPrevSearchAfterKey , searchKey);

            this.customersStopScroll = true;
          }

          this.customersPrevSearchAfterKey = searchKey;

        }
        this.customerLoading = false;
        this.customerLoadingMore = false;
        this.isLoading = false;
      }, () => {
        this.customerLoading = false;
        this.customerLoadingMore = false;
        this.isLoading = false;
      });
    }
    else{
      // Membership tier makes this a no-op (no Customer reload). Make sure a
      // network-select that armed the loaders doesn't leave them stuck.
      this.customerLoading = false;
      this.customerLoadingMore = false;
      this.isLoading = false;
    }
  }



  onExperienceValueChange() {
    let selectedValue: any;
    selectedValue = this.jobFilterForm.get('experienceType').value;
    if (selectedValue == GigsumoConstants.EXPERIENCE_JUNIOR) {
      this.jobFilterForm.patchValue({ experienceFrom: 1, experienceTo: 3 });
    } else if (selectedValue == GigsumoConstants.EXPERIENCE_MID_LEVEL) {
      this.jobFilterForm.patchValue({ experienceFrom: 4, experienceTo: 6 });
    } else if (selectedValue == GigsumoConstants.EXPERIENCE_SENIOR) {
      this.jobFilterForm.patchValue({ experienceFrom: 6, experienceTo: 10 });
    } else if (selectedValue == GigsumoConstants.EXPERIENCE_ARCHITECT) {
      this.jobFilterForm.patchValue({ experienceFrom: 10, experienceTo: 20 });
    } else {
      this.jobFilterForm.patchValue({ experienceFrom: null, experienceTo: null });
    }
    this.updateFunction();
  }

  onPostedDaysChange() {
    let selectedValue: any;
    selectedValue = this.jobFilterForm.get('postedDayRange').value;
    if (selectedValue == GigsumoConstants.POSTED_TODAY) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 1 });
    } else if (selectedValue == GigsumoConstants.POSTED_LAST_7_DAYS) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 7 });
    } else if (selectedValue == GigsumoConstants.POSTED_LAST_14_DAYS) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 14 });
    } else if (selectedValue == GigsumoConstants.POSTED_LAST_30_DAYS) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 30 });
    } else {
      this.jobFilterForm.patchValue({ postedFrom: null, postedTo: null });
    }
    this.updateFunction();
  }

  updateJobFilterData() {
    const userType = localStorage.getItem('userType') as USER_TYPE;
    if (this.isMTAorFREEandREC(userType)) {
      this.owner = true;
    }
    else if (this.isBench(userType)) {
      this.owner = false;
    }
  }

  isRecruiter(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.RECRUITER);
  }

  isBench(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.BENCH_RECRUITER);
  }

  isMTAorFREEandREC(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION
      || userType === GigsumoConstants.FREELANCE_RECRUITER || userType === GigsumoConstants.RECRUITER);
  }

  isMTAorFREE(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || userType === GigsumoConstants.FREELANCE_RECRUITER);
  }

  settingUpFilters() {
    if (!this.isMyJobsShowedOnLoad && this.networkflag == false && !this.queryParamValues.networkflag
      && this.jobSourceSearchRoute == null) {
      this.jobSource.push('marketPlaceJobs')
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);
      this.applyFilternew();
    } else if (this.owner && this.isMyJobsShowedOnLoad && this.networkflag == false && !this.queryParamValues.networkflag
      && this.jobSourceSearchRoute == null) {
      this.jobSource.push('myJobs')
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);
      this.applyFilternew();
    } else if (this.networkflag == true && this.queryParamValues.networkflag) {
      this.jobSource.push(this.jobSourceSelectNetRoute)
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(this.jobSourceSelectNetRoute).patchValue(true);
      this.applyFilternew();
    } else if (this.jobSourceSearchRoute != null) {
      this.jobSource = []
      this.jobSource.push(this.jobSourceSearchRoute)
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).patchValue({
        all: false,
        myJobs: false,
        marketPlaceJobs: false,
        teamJobs: false,
        recruiterNetworkJobs: false,
        freeLancerNetworkJobs: false,
        mtaNetworkJobs: false,
        featured: false,
        suggestedJobs: false,
      });
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(this.jobSourceSearchRoute).patchValue(true);
      this.applyFilternew();
    }
  }

  listingDeactivatedJobs() {
    var userid = localStorage.getItem('userId');
    var userType = localStorage.getItem('userType');
    let profiledata: any = {}
    profiledata.userId = userid;
    profiledata.userType = userType;
    const format = 'dd-MM-yyyy';
    const locale = 'en-US';
    let lastLoggedTime: any = localStorage.getItem('lastLogged');

    if (lastLoggedTime != null && lastLoggedTime != undefined) {

      let datas: any = {}

      this.apiService.create('user/profileDetails', profiledata).subscribe(profileres => {
        let logged = new Date(lastLoggedTime);
        let today = new Date();

        const lastloggedYesterday = this.dateInPast(logged);
        if (formatDate(logged, format, locale) < formatDate(today, format, locale) || lastloggedYesterday) {
          if (profileres != undefined && profileres.code === "00000") {
            this.sendProfileData = profileres;

            this.availablePoints = profileres.data.creditPoints;



            this.apiService.query('jobs/listingDeactivatedJobsandCandidates/' + userid + "/" + userType).subscribe(res => {

              if (res.code === "00000" && res.data.deactivatedJobs != undefined) {

                this.deactivatedJobs = res.data.deactivatedJobs;
                this.totalCount = this.deactivatedJobs.length;

                let totalcredit = profileres.data.creditPoints;
                let sum = 0;
                this.deactivatedJobs.forEach(element => {

                  element.isSelected = false;

                  if (element.isFeatured == true) {
                    datas = profileres.data.creditConsumptions.find(item => item.creditType === AppSettings.UPGRADED_JOB);
                    sum = sum + datas.points;
                    element.points = datas.points
                    element.consumptionType = datas.creditType;
                  }
                  else {
                    datas = profileres.data.creditConsumptions.find(item => item.creditType === AppSettings.CREATE_JOB);
                    sum = sum + datas.points;
                    element.points = datas.points;
                    element.consumptionType = datas.creditType;
                  }
                });
                this.deactivatedJobs[0].totalpoints = sum;
                if (sum < totalcredit) {
                  this.validTotalPoints = true;
                }
                else {
                  this.validTotalPoints = false;
                }

                //validating popup to appear only one day

                let ngbModalOptions: NgbModalOptions = { backdrop: 'static', keyboard: false };
                let checkModalOpenedToday: any = localStorage.getItem(userid + '_jobmodalOpened');

                if (checkModalOpenedToday != null || checkModalOpenedToday != undefined) {

                  const openedDate = new Date(checkModalOpenedToday.toString());

                  // openedDate.valueOf() < endofDay;
                  const checkDateIfYesterDay = this.dateInPast(openedDate);

                  if (checkDateIfYesterDay) {
                    this.listingCount = 0;
                    localStorage.removeItem(userid + '_jobmodalOpened')
                  }
                  else if (!checkDateIfYesterDay) {
                    this.listingCount++;
                  }
                }

                if (this.listingCount >= 1) {
                  return;
                }
                const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
                //this.modalRef = this.modalService.show(this.listingmodal, config);
                setTimeout(() => {
                  localStorage.setItem(userid + '_jobmodalOpened', String(today));
                }, 1000);
                // $('body').css('position','fixed').css('overflow', 'hidden');
                this.stopscrollFlag = true;

              }

            });

          }
        }
      });


    }

  }

  dateInPast(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }

  onLoad() {
    let data: any = JSON.parse(localStorage.getItem('jobForm'));
    for (let key in data.source) {
      if (data.source[key] === true) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.jobSource.push(key)
        this.jobSource.forEach((ele, index) => {
          if (this.FeaSugg && ele === "featured" || this.FeaSugg && ele === "suggestedJobs") {
            this.jobSource.splice(index, 1)
          }
          if (!this.owner && ele === "myJobs") {
            this.jobSource.splice(index, 1)
          }
        })
      }
    }
    data.clientType.forEach((res) => {
      this.clientTypeCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.jobSource.push(res)
        }
      });
    });
    data.status.forEach((res) => {
      this.statusCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.jobSource.push(res)
        }
      });
    });
    data.jobClassification.forEach((res) => {
      this.jobclasscificationCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.jobSource.push(res)
        }
      });
    });
    for (let key in data.workType) {
      if (data.workType[key] === true) {
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.jobSource.push(key)
      }
    }

    this.jobSource = [...new Set(this.jobSource)]
    this.jobSource.forEach((ele, index) => {
      if (ele === "All" || ele === "all") {
        this.jobSource.splice(index, 1)
      }
    })
    this.value = data.experienceFrom != null ? data.experienceFrom : 0;
    this.highValue = data.experienceTo != null ? data.experienceTo : 0;
    this.value1 = data.postedFrom != null ? data.postedFrom : 0;
    this.highValue1 = data.postedTo != null ? data.postedTo : 0;


    this.jobFilterForm.get('country').patchValue(data.country)
    this.jobFilterForm.get('state').patchValue(data.state)
    this.jobFilterForm.get('city').patchValue(data.city)
    this.jobFilterForm.get('zipCode').patchValue(data.zipCode)

    localStorage.setItem('jobSource', this.jobSource);
  }

  get jobSourcesFormarray() {
    return this.jobFilterForm.get('source') as FormArray;
  }

  // @Output() clientTypeChecked = new EventEmitter<any>();
  clientTypecheck(event, lable, param?: any) {
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    this.stopscrollFlag = false
    let allData =[];
    this.clientTypeCheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
      if(item.label != 'All'){
        allData.push(item);
      }
    });

    this.response = []
    this.data1.searchAfterKey = null;
    if (event.target.checked == true) {
      this.ischeckedClientType = true;

      if (lable == 'All') {
        for (let key of this.clientTypeCheckboxes) {
          if (key.label != 'All') {
            this.jobSource.push(key.label);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      } else {
        this.jobSource.push(lable);
        this.jobSource = [...new Set(this.jobSource)]
      }

      if(allData.every(x=> x.selected == true)){
        this.clientTypeCheckboxes[0].selected = true;
      }

    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.clientTypeCheckboxes[0].selected = false;
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }

      }

      if (lable == 'All') {
        for (let key of this.clientTypeCheckboxes) {
          if (this.jobSource.includes(key.label) && key.label != 'All') {
            this.jobSource.splice(this.jobSource.indexOf(key.label), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      }
      // this.clientTypeChecked.emit({event, lable, param});
    }

    if (this.ischeckedClientType && this.ischeckedClientTypeAll) {
      event.target.checked = true
    }
    // this.filterWhenNoneJobSouce()
    // this.cdr.detectChanges();
    this.updateFunction()
  }

  // used to sent filter data to parent new-job Component on every click
  updateFunction() {
    let personalNetworkData = [];
    if (this.jobSource) {

      this.jobSource.forEach(element => {
        this.personalNetworks.forEach(x => {
          if (x.key === element) {
            personalNetworkData.push(x.networkId);
          }
        });
      });
    }

    const isBusinessNetwork = this.jobSourcesFormarray.at(0)!=undefined && this.jobSourcesFormarray.at(0).get('businessNetwork').value;
    const data  = (this.selectedBusinessNetworks && this.selectedBusinessNetworks.length > 0) ? this.selectedBusinessNetworks : (isBusinessNetwork ? (this.businessNetworkData!= undefined ? this.businessNetworkData.map(x => x.b2bNetworkId) : []) : []) ;

    this.jobFilterForm.get('resetFilter').patchValue(false);

    if (this.jobFilterData) {
      this.jobFilterData.clickHandler.apply(this.jobFilterData.source,
        [{
          formData: this.jobFilterForm.getRawValue(),
          checkedItems: this.jobSource,
          jobClassifications: this.jobclasscificationCheckboxes,
          statusCheckedItems: this.statusCheckboxes,
          clientTypeCheckedItems: this.clientTypeCheckboxes,
          createdByTypeCheckedItems: this.createdByypesCheckboxes,
          personalNetworks: personalNetworkData,
          businessNetworks: data,
          publishedByUsers: this.selectedPublishedBy,
          selectedEmployees: this.selectedEmployees,
          businessCustomers: this.selectedCustomers,
          customerSelectedData: this.customerPrevSelectedValue,
          workMode : this.workModeCheckboxes,
          publishedSelectedData: this.publishedByPrevSelectedValue,
          businessNetworkSelectedData: this.businessNetworkPrevSelectedValue,
          from: "VERTICAL"
        }]);
    }
  }

  // filterWhenNoneJobSouce() {
  //   if (!this.owner) {
  //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false) {

  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).patchValue({
  //         teamJobs: true,
  //         recruiterNetworkJobs: true,
  //         freeLancerNetworkJobs: true,
  //         mtaNetworkJobs: true,
  //         featured: true,
  //         suggestedJobs: true
  //       })


  //       this.jobSource.push("teamJobs");
  //       this.jobSource.push("recruiterNetworkJobs");
  //       this.jobSource.push("freeLancerNetworkJobs");
  //       this.jobSource.push("MTA Network");
  //       if (!this.FeaSugg) {
  //         this.jobSource.push("featured");
  //         this.jobSource.push("suggestedJobs");
  //       }

  //       this.jobSource = [...new Set(this.jobSource)]
  //     }
  //   }
  //   if (this.owner && this.isMyJobsShowedOnLoad) {
  //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);
  //       this.jobSource.push("myJobs");
  //       this.jobSource = [...new Set(this.jobSource)]
  //     }
  //   } else if (!this.isMyJobsShowedOnLoad) {
  //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);
  //       this.jobSource.push("marketPlaceJobs");
  //       this.jobSource = [...new Set(this.jobSource)]
  //     }
  //   }
  // }

  totalCountJob: number = 0;

  statuscheckbox(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    let allData =[];

    this.statusCheckboxes.forEach(item => {
      if (lable === 'Active') {
        this.activeStatus = true
      }
      else {
        this.activeStatus = false
      }
      if (item.label == lable) {
        item.selected = event.target.checked;
      }

      if(item.label != 'All'){
        allData.push(item);
      }
    });

    if (event.target.checked == true) {
      this.ischeckedJobClassification = true;
      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (key.label != 'All' && !this.jobSource.includes(key)) {
            this.jobSource.push(key.label);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.statusCheckAll(event);
      }
      else {

        this.jobSource.push(lable);
        this.jobSource = [...new Set(this.jobSource)]

      }

      if(allData.every(x=> x.selected == true)){
        this.statusCheckboxes[0].selected = true;
      }

    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.statusCheckboxes[0].selected = false;
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (this.jobSource.includes(key.label) && key.label != 'All') {
            this.jobSource.splice(this.jobSource.indexOf(key.label), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.statusCheckAll(event);
      }

    }

    if (this.ischeckedJobClassification && this.ischeckedJobClassificationAll) {
      event.target.checked = true
    }


    // if (this.activeStatus) {

    //   if (!this.owner) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

    //       this.jobSource.push("teamJobs");
    //       this.jobSource.push("recruiterNetworkJobs");
    //       this.jobSource.push("freeLancerNetworkJobs");
    //       this.jobSource.push("MTA Network");
    //       if (!this.FeaSugg) {
    //         this.jobSource.push("featured");
    //         this.jobSource.push("suggestedJobs");
    //       }

    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   }
    //   if (this.owner) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

    //       this.jobSource.push("myJobs");
    //       this.jobSource.push("recruiterNetworkJobs");
    //       if (!this.FeaSugg) {
    //         this.jobSource.push("featured");
    //         this.jobSource.push("suggestedJobs");
    //       }
    //       this.jobSource.push("freeLancerNetworkJobs");
    //       this.jobSource.push("mtaNetworkJobs");
    //       this.jobSource.push("teamJobs");
    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   }

    //   this.activeStatus = null;
    // }
    // else if (!this.activeStatus) {

    //   if (this.owner && this.isMyJobsShowedOnLoad) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);

    //       this.jobSource.push("myJobs");

    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   } else if (!this.isMyJobsShowedOnLoad) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);
    //       this.jobSource.push("marketPlaceJobs");
    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   }

    //   this.activeStatus = null;
    // }
    this.updateFunction();
  }



  FeaSugg: boolean = false;
  activeFilterElement: Array<any> = [];

  JobSeekerRole = ["all", "marketPlaceJobs", "memberNetworksJobs"];
  jobSoucecheck(event, lable, param?: any) {
    this.response = []
    this.stopscrollFlag = false
    this.data1.searchAfterKey = null;

    // SuperAdmin "My Employees" toggle.
    //   ON  → tell parent to fetch findEmployeeList; parent's loading
    //          flag drives the picker's spinner during the call.
    //   OFF → keep the picker mounted briefly with the spinner visible
    //          (matches the on-toggle UX), then let *ngIf hide it.
    //          No API call on off — purely visual feedback.
    // Re-ticking ON within the off window cancels the timer so the
    // picker stays mounted continuously without a hide-show flash.
    if (lable === 'myEmployees' && this.orgJobsMode) {
      if (event.target.checked === true) {
        if (this.employeeOffTimer) {
          clearTimeout(this.employeeOffTimer);
          this.employeeOffTimer = null;
        }
        this.employeeOffShowing = false;
        this.employeeOffLoading = false;
        this.myEmployeesToggled.emit();
      } else {
        this.employeeOffShowing = true;
        this.employeeOffLoading = true;
        if (this.employeeOffTimer) clearTimeout(this.employeeOffTimer);
        // 500ms — matches the existing pauseForSeconds(500) used elsewhere
        // in this template for inter-API pauses, so the off-toggle spinner
        // feels consistent with the rest of the filter slider's timings.
        this.employeeOffTimer = setTimeout(() => {
          this.employeeOffShowing = false;
          this.employeeOffLoading = false;
          this.employeeOffTimer = null;
        }, 500);

        // Removing "My Employees" must also drop any employee the user had
        // picked. Otherwise their userId lingers in selectedEmployees and is
        // folded into publishedBy on the next Apply, so their jobs keep
        // showing. Same picker-clearing the Reset handler does above.
        this.selectedEmployees = [];
        this.employeePrevSelectedValue = [];
        const currentEmployees = this.employeeList.getValue();
        if (currentEmployees && currentEmployees.length > 0) {
          this.employeeList.next(currentEmployees.map(item => ({ ...item, enabled: false })));
        }

        // Also refetch findEmployeeList on OFF so the picker's cached data
        // is refreshed (matches the ON behaviour). The parent's
        // onMyEmployeesToggled handler resets the search/pagination state
        // and refires findEmployeeList. Picker stays hidden via *ngIf, so
        // the fresh list is just cached for the next ON toggle.
        this.myEmployeesToggled.emit();
      }
    }



    if (event.target.checked == true && this.userType != GigsumoConstants.JOB_SEEKER) {
      if (lable == 'myJobs') {
        this.response = []
        this.obj.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
      for (let key of this.keyarrayjobsouces) {
        if (lable == 'all' && key != 'all') {
          if (key === 'myJobs' && this.owner && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'teamJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'recruiterNetworkJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'freeLancerNetworkJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'mtaNetworkJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'featured' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]
          } else if (key == 'suggestedJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]
          } else if (key == 'marketPlaceJobs' && this.owner && !this.jobSource.includes(key)) {
            // when platform jobs is selected it does not require other sources
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]
          }
        } else {
          if (lable != 'all' && !this.jobSource.includes(lable)) {
            this.jobSource.push(lable);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
      }

      if(this.checkIfAllSourceIsSelected()){
        this.jobSourcesFormarray.at(0).get('all').patchValue(true);
      }
    }
    else if (event.target.checked == false && this.userType != GigsumoConstants.JOB_SEEKER) {
      if (lable != 'all') {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(event.target.checked);
      }

      if (lable == 'myJobs') {
        this.response = []
        this.obj.searchAfterKey = null;
        this.data1.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
      if (lable == 'all') {
        for (let key of this.keyarrayjobsouces) {
          if (this.jobSource.includes(key)) {
            this.jobSource.splice(this.jobSource.indexOf(key), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
      } else {
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }
      }
    }

    if (this.userType === GigsumoConstants.JOB_SEEKER) {
      const sourceFormArray = (this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup;
      const formValues = this.jobFilterForm.get('source').value;

      if (lable === 'all') {
        this.jobSource = [];
        this.JobSeekerRole.forEach(key => {
        sourceFormArray.get(key).patchValue(event.target.checked);
        this.jobSource.push(key);
        });
      } else {
        sourceFormArray.get(lable).patchValue(event.target.checked);
        if (event.target.checked) {
          this.jobSource.push(lable);
          sourceFormArray.get('all').patchValue(formValues[0].marketPlaceJobs && formValues[0].memberNetworksJobs);
        } else {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
          sourceFormArray.get('all').patchValue(false);
        }
      }

      this.jobSource = Array.from(new Set(this.jobSource));
    }


    let personalNetworkData = [];
    this.jobSource.forEach(element => {
      this.personalNetworks.forEach(x => {
        if (x.key === element) {
          personalNetworkData.push(x.networkId);
        }
      });
    });


    if (lable === 'all') {
      let isChecked = event.target.checked;
      if (this.userType != GigsumoConstants.JOB_SEEKER) {
        this.jobsouceCheckedAll(isChecked);
        if (isChecked) {
          this.jobSource = [];
          Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key => {
            this.jobSource.push(key);
          });
        }
        else {
          this.jobSource = [];
        }
      }

      this.setToDefaulFilter();
      this.publishedPayload.memberNetworkChosen = isChecked;
      this.publishedPayload.personalNetworks = isChecked ? this.allPersonalNetworks : [];

      if (this.businessNetworkData && this.businessNetworkData.length > 0) {
        this.setToDefaulFilter("CUSTOMER");
        this.customerPayload.businessNetworks = isChecked ? this.allBusinessNetwork : [];
        this.getBusinessCustomers();
      }

      this.getPublishedBy();
    }


    if (lable === "memberNetworksJobs") {
      this.setToDefaulFilter("CUSTOMER");
      let isMemberNetworkTrue = this.jobSourcesFormarray.at(0).get(lable).value;
      this.customerPayload.memberNetworkChosen =  isMemberNetworkTrue;
      this.customerPayload.businessNetworks = this.selectedBusinessNetworks === undefined ? [] : this.selectedBusinessNetworks;
      // Member Network source reloads the Customer list — global overlay.
      this.isLoading = true;
      this.getBusinessCustomers("MEMBER_NETWORK", 'global');
    }
    else if (lable === "businessNetwork") {
      this.istempBusinessNetwork = this.jobSourcesFormarray.at(0).get(lable).value;
      this.setToDefaulFilter("CUSTOMER");
      this.customerPayload.businessNetworkChosen = this.istempBusinessNetwork;
      this.customerPayload.businessNetworks = event.target.checked ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
      this.selectedBusinessNetworks = this.istempBusinessNetwork ? this.customerPayload.businessNetworks : [];
      this.businessNetworkPrevSelectedValue = [];
      this.businessNetworkData =  this.tempBusinessNetworks.map(x => {
        x.enabled = false;
        return x;
      });
      // Selecting the Business Network source reloads the Customer list —
      // show the global panel overlay while it does.
      this.isLoading = true;
      this.getBusinessCustomers("BUSINESS-NETWORK", 'global');
    }
    else if (lable === "eligibleSubContractJobs") {
      this.setToDefaulFilter("CUSTOMER");
      let isSubContractingTrue = this.jobSourcesFormarray.at(0).get(lable).value;
      this.customerPayload.subContractingChosen = isSubContractingTrue;
      this.customerPayload.memberNetworkChosen = false;
      this.customerPayload.businessNetworkChosen = false;
      // Sub-Contracting source reloads the Customer list — global overlay.
      this.isLoading = true;
      this.getBusinessCustomers("BUSINESS-NETWORK", 'global');
    }
    else if (param === "personalNetworks") {
        this.setToDefaulFilter();
        this.publishedPayload.personalNetworks = personalNetworkData;
        this.getPublishedBy();
    }

    const isMyJobsChecked : boolean  = this.jobSourcesFormarray.at(0) != undefined ? this.jobSourcesFormarray.at(0).get('myJobs').value : false;
    // Keep Draft enabled in SuperAdmin org-scoped view (orgJobsMode) even
    // when only "My Employees" is ticked instead of "My Jobs".
    this.statusCheckboxes = updateStatusCheckBox(this.statusCheckboxes , this.orgJobsMode || isMyJobsChecked);

    this.updateFunction();
  }

  // Only the checkboxes the template actually renders — mirrors the *ngIf's in
  // the Source panel (incl. the SuperAdmin orgJobsMode view). Hidden controls
  // (recruiterNetworkJobs, featured, myEmployees outside orgJobsMode, …) can
  // never be ticked one by one, so they mustn't block the auto-"All".
  private visibleSourceKeys(): string[] {
    if (this.orgJobsMode) {
      return ['myJobs', 'myEmployees'];
    }
    const keys = ['marketPlaceJobs', 'memberNetworksJobs'];
    if (this.owner) keys.push('myJobs');
    if (!this.filterApplied) {
      keys.push(...(this.personalNetworks || []).map(x => x.key));
      if (this.userType != GigsumoConstants.JOB_SEEKER) keys.push('teamJobs');
    }
    if (this.userType != GigsumoConstants.JOB_SEEKER && this.businessNetworkData?.length > 0) keys.push('businessNetwork');
    if (this.userType != GigsumoConstants.JOB_SEEKER && this.membershipType !== 'Free') keys.push('eligibleSubContractJobs');
    return keys;
  }

  checkIfAllSourceIsSelected() {
    const group = this.jobSourcesFormarray.at(0) as UntypedFormGroup;
    if (!group) return false;
    return this.visibleSourceKeys().every(key => group.get(key)?.value === true);
  }



  get allBusinessNetwork() {
    return this.businessNetworkData ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
  }

  get allPersonalNetworks(){
    return this.personalNetworks ? this.personalNetworks.map(x => x.networkId) : [];
  }

  setToDefaulFilter(d = "Published") {
    if (d === "Published") {

      this.publishedPayload.searchAfterKey = null;
      this.publishedByStopScroll = false;
      this.publishedByPrevSearchAfterKey = null;
      // this.publishedByPrevSelectedValue = [];
      this.publishedByList.next([]);
    }
    else {
      this.customerPayload.searchAfterKey = null;
      this.customersStopScroll = false;
      this.customersPrevSearchAfterKey = null;
      // this.customerPrevSelectedValue = [];
      this.customersList.next([]);
    }
  }

  jobsouceCheckedAll(checked) {
    Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key => {
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(checked);
    });
  }

  jobclassficheckbox(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    let allData =[];
    this.jobclasscificationCheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
      if(item.label != 'All'){
        allData.push(item);
      }
    });


    if (event.target.checked == true) {
      this.ischeckedStatus = true;
      if (lable == 'All') {
        for (let key of this.jobclasscificationCheckboxes) {
          if (key.label != 'All' && !this.jobSource.includes(key)) {
            this.jobSource.push(key.label);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      } else {
        if (!this.jobSource.includes(lable)) {

          this.jobSource.push(lable);
          this.jobSource = [...new Set(this.jobSource)]
        }

      }

      if(allData.every(x=> x.selected == true)){
        this.jobclasscificationCheckboxes[0].selected = true;
      }
    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.jobclasscificationCheckboxes[0].selected = false;
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.jobclasscificationCheckboxes) {
          if (this.jobSource.includes(key.label) && key.label != 'All') {
            this.jobSource.splice(this.jobSource.indexOf(key.label), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      }
    }

    if (this.ischeckedStatus && this.ischeckedStatusAll) {
      event.target.checked = true
    }
    // this.filterWhenNoneJobSouce()
    this.updateFunction();
  }

  workTypecheckboxCheckAll(event) {
    const checked = event.target.checked;
    for (let key of this.keysarrWorks) {
      ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(checked);
    }
  }

  workTypecheckbox(event, lable) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    if (event.target.checked == true) {
      if (lable == 'all') {
        for (let key of this.keysarrWorks) {
          if (key != 'all' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.workTypecheckboxCheckAll(event);
      } else {
        if (!this.jobSource.includes(lable)) {
          this.jobSource.push(lable);
          this.jobSource = [...new Set(this.jobSource)]
        }

      }



    }
    else if (event.target.checked == false) {
      if (lable == 'all') {
        for (let key of this.keysarrWorks) {
          if (this.jobSource.includes(key)) {
            this.jobSource.splice(this.jobSource.indexOf(key), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.workTypecheckboxCheckAll(event);
      } else {
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }
      }


      if (lable != 'all') {
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(event.target.checked);
      }

    }

    // this.filterWhenNoneJobSouce()
    this.updateFunction();
  }

  stateListCA: any;
  stateListIN: any;
  stateListAU: any;
  countryList: any = [];
  onChangeCountry(event) {
    this.jobFilterForm.get('state').patchValue(null)
    this.jobFilterForm.get('city').patchValue(null)
    this.jobFilterForm.get('zipCode').patchValue(null)
    this.jobFilterForm.value.country = event;
    this.response = [];
    // this.filterWhenNoneJobSouce()
    this.applyFilternew();
    if (event == "US") {
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListAU = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListIN = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListCA = res;
        }, err => {
          this.util.stopLoader();
        });
    }
    this.updateFunction();
  }

  createdByypesCheckboxes = [
    { label: 'All', selected: false, control: 'all' },
    { label: 'Owner', selected: false, control: 'owner' },
    { label: 'Systems Integrator', selected: false, control: 'systemsIntergrator' },
    { label: 'Prime Vendor', selected: false, control: 'primeVendor' },
    { label: 'Vendor/ Staffing Agency', selected: false, control: 'vendorStaffingAgency' },
  ];

  createdByCheckAll(event) {
    const checked = event.target.checked;
    this.createdByypesCheckboxes.forEach(item => item.selected = checked);
  }

  onSelectCreatedBy(event, control, param?: any) {
    this.createdByypesCheckboxes.forEach(item => {
      if (item.control == control) {
        item.selected = event.target.checked;
      }
    });

    if (event.target.checked == true) {
      this.ischeckedStatus = true;
      if (control == 'all') {
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.patchValue({ owner: true, all: true, systemsIntergrator: true, primeVendor: true, vendorStaffingAgency: true })
        this.createdByCheckAll(event);
      } else {
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.get(control).patchValue(true);
        if (this.createdByypesCheckboxes[0].control == control) {
          this.createdByypesCheckboxes[0].selected = true;
        }
      }
    }
    if (event.target.checked == false) {
      if (control == 'all') {
        this.createdByCheckAll(event);
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.patchValue({ owner: false, all: false, systemsIntergrator: false, primeVendor: false, vendorStaffingAgency: false });
      } else {
        if (control == this.createdByypesCheckboxes[0].control) {
          this.createdByypesCheckboxes[0].selected = false;
        }
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.get(control).patchValue(false);
        nestedForm.get('all').patchValue(false);
      }
    }
    this.applyFilternew(param);
    this.updateFunction();
  }

  onKeyZip(event: any) {
    let data: any = {};
    data.countryCode = "US";
    data.zipCode = event.target.value;
    data.stateCode = "";
    if (data.zipCode.length === 5) {
      // Capture the ZIP we're requesting so we can detect if the user
      // edits the field while the geo call is in flight (race condition).
      const requestedZip = data.zipCode;
      this.apiService.create("country/geodetails", data).subscribe((res) => {
        // Guard against the race condition where the user backspaces
        // (12390 → 123) between the geo request and its response:
        //   • without this guard we'd patch city/state that belong to
        //     the OLD zip and then updateFunction() would snapshot the
        //     form as {zipCode:'123', city:'Schenectady', state:'NY'},
        //   • the parent would then send those mismatched values on
        //     Apply, producing the exact "geo=12390 but filter=123"
        //     bug the user reported.
        // Skip everything if the current form's zip no longer matches
        // what we asked geo about.
        if (this.jobFilterForm.value.zipCode !== requestedZip) {
          return;
        }
        if (
          res &&
          res != null &&
          res != "" &&
          res.length > 0 &&
          event.target.value != ""
        ) {

          res.forEach((ele) => {
            let cityName = ele.cityName;
            let stateName = ele.stateName;
            this.jobFilterForm.patchValue({
              city: cityName,
              state: stateName,
            });
          });
          // City and state inputs are `disabled` for US, so they can only
          // be filled in via this geo lookup. Without notifying the parent
          // here, the parent's tempFilterChanges keeps stale null values
          // and Apply sends city='' / state='' to the backend — the user
          // ends up filtering by only country+zipCode even though the UI
          // visually shows city/state populated.
          this.updateFunction();
        }
      }, err => {
        this.util.stopLoader();
      });
    } else {
      // ZIP is not a valid 5-digit code (user typed only 1–4 digits, went
      // over 5, or emptied the field entirely). Two things must happen so
      // Apply sends only what's actually in the field right now:
      //   1. Clear the geo-derived city + state. They were filled in by
      //      the previous 5-digit lookup and are now stale — the US
      //      city/state inputs are `disabled`, so the user can't clear
      //      them by hand.
      //   2. Push the fresh snapshot to the parent via updateFunction()
      //      so tempFilterChanges reflects the currently-typed ZIP. Without
      //      this the parent keeps the old snapshot and applyFilter…toPayload
      //      would ship stale zipCode/city/state to the backend.
      // Backend decides matches — no results is fine per the business
      // rule "let the user search anything".
      this.jobFilterForm.patchValue({ city: null, state: null });
      this.updateFunction();
    }
  }

  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }

  jobclassifiCheckAll(event) {
    const checked = event.target.checked;
    this.jobclasscificationCheckboxes.forEach(item => item.selected = checked);
  }

  onChangestate(state) {
    this.jobFilterForm.value.state = state;
    this.response = [];
    this.data1.searchAfterKey = null;
    // Clear City/ZIP only when State was chosen from a dropdown (CA/IN/AU).
    // For free-text State countries the user types both City and State, so
    // nothing should be wiped. (orgJobsMode still scopes the remove guard.)
    const stateFromDropdown = ['CA', 'IN', 'AU'].indexOf(this.jobFilterForm.value.country) > -1;
    if (stateFromDropdown && (state || !this.orgJobsMode)) {
      this.jobFilterForm.get('city').patchValue(null)
      this.jobFilterForm.get('zipCode').patchValue(null)
    }
    this.updateFunction();

    // this.filterWhenNoneJobSouce()
    this.applyFilternew();
  }

  onChangecity(city) {
    this.response = [];
    this.jobFilterForm.value.city = city;
    this.data1.searchAfterKey = null;
    // Scope the "don't clear on remove" guard to SuperAdmin Job Center
    // (orgJobsMode) only. Regular Job page keeps the original cascade-
    // clear behaviour.
    if (city || !this.orgJobsMode) {
      this.jobFilterForm.get('zipCode').patchValue(null)
    }
    this.updateFunction();
    // this.filterWhenNoneJobSouce()
    this.applyFilternew();
  }

  onChangezipcode(zipcode) {
    this.response = [];
    this.jobFilterForm.value.zipCode = zipcode;
    this.data1.searchAfterKey = null;
    this.updateFunction();
    // this.filterWhenNoneJobSouce()
    this.applyFilternew();
  }

  yearApplied: boolean = false
  onChangeYear(value) {

    if (value.highValue > 0) {
      this.yearApplied = true
    } else if (value.highValue == 0) {
      this.yearApplied = false
    }
    this.jobFilterForm.get('experienceFrom').patchValue(value.value);
    this.jobFilterForm.get('experienceTo').patchValue(value.highValue);
    // this.filterWhenNoneJobSouce()
    this.applyFilternew();
    this.updateFunction();
    // value.value
  }
  daysApplied: boolean = false
  onChangedays(value, param?: any) {


    if (value.highValue > 0) {
      this.daysApplied = true
    } else if (value.highValue == 0) {
      this.daysApplied = false
    }
    this.jobFilterForm.get('postedFrom').patchValue(value.value);
    this.jobFilterForm.get('postedTo').patchValue(value.highValue)
    // this.filterWhenNoneJobSouce()
    this.applyFilternew(param);
    this.updateFunction();
    // value.value
  }

  cancel() {
    // this.router.navigate(["newcandidates"])
  }

  resetFilternew() {
    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;
    this.jobSource = ['myJobs'];
    this.response = []
    this.obj.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    if (this.jobFilterForm != undefined) {
      this.jobFilterForm.get('state').patchValue(null)
      this.jobFilterForm.get('country').patchValue(null)
      this.jobFilterForm.get('city').patchValue(null)
      this.jobFilterForm.get('zipCode').patchValue(null)


      this.clientTypeCheckboxes.forEach(item => item.selected = false);
      this.statusCheckboxes.forEach(item => item.selected = false);
      this.jobclasscificationCheckboxes.forEach(item => item.selected = false);

      for (let key of this.keyarrayjobsouces) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }

      for (let key of this.keysarrWorks) {
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }

      if (this.owner && this.isMyJobsShowedOnLoad) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);
      } else if (!this.isMyJobsShowedOnLoad) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);
      }
      // this.response = [];
      this.data1.searchAfterKey = null;
      this.data.searchAfterKey = null;
      this.applyFilternew();

    }

  }

  createjobFilterForm() {
    this.jobFilterForm = this.formBuilder.group({
      source: this.formBuilder.array([]),
      workMode: [],
      jobClassification: null,
      clientType: null,
      status: ["Active"],
      userId: localStorage.getItem('userId'),
      country: null,
      state: null,
      city: null,
      zipCode: null,
      experienceFrom: null,
      experienceTo: null,
      postedFrom: null,
      postedTo: null,
      resetFilter : false,
      experienceType: 'Any (Years)',
      // Must match GigsumoConstants.POSTED_ANY ("Any (Days)") — see the
      // matching note in resetOrgJobsFilterUiState() above. Mismatched
      // strings left the "Any" radio unselected and the count badge stuck.
      postedDayRange: GigsumoConstants.POSTED_ANY,
      organisationTypeParams: this.formBuilder.group({
        all: false,
        owner: false,
        systemsIntergrator: false,
        primeVendor: false,
        vendorStaffingAgency: false
      }),
    })

  }

  @Output() panelValue = new EventEmitter<any>(null);
  @Output() valuesRetainedForFilters = new EventEmitter<any>(null);
  startFilter() {
    let data: any = {}
    const jobSource = JSON.parse(localStorage.getItem('jobSource'))
    const jobForm = JSON.parse(localStorage.getItem('jobForm'))
    data.jobSource = jobSource;
    data.jobForm = jobForm
    const jsonData = JSON.stringify(data);
    this.panelValue.emit('jobs')
    this.valuesRetainedForFilters.emit(jsonData);
  }


  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.apiService.query("country/getAllCountries").subscribe((res) => {
      this.util.stopLoader();
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }


  clientTypeCheckedAll(event) {
    const checked = event.target.checked;
    this.clientTypeCheckboxes.forEach(item => item.selected = checked);

  }

  jobsoucefilterFrom(d) {
    this.jobSourcesFormarray.push(this.jobService.jobSourcefields(d));
    this.jobFilterForm.patchValue(this.jobFilterFormData);
  }

  applyFilternew(param?: any) {
    return;

    this.stopscrollFlag = false;

    var statusCheckboxesUpdate: any = [];
    this.statusCheckboxes.forEach(element => {
      if (element.selected) {
        statusCheckboxesUpdate.push(element.label)
      }
    });

    var clientTypeCheckboxesUpdate: any = [];
    this.clientTypeCheckboxes.forEach(element => {
      if (element.selected) {
        clientTypeCheckboxesUpdate.push(element.label)
      }
    });

    var jobClassificationUpdate = [];
    this.jobclasscificationCheckboxes.forEach(element => {
      if (element.selected) {
        jobClassificationUpdate.push(element.label)
      }
    });


    if (!this.filterApplied) {
      const source = this.jobFilterForm.get('source').value;

      this.data1.source = { ...this.jobFilterForm.value.source[0] };
      this.data1.workType = { ...this.jobFilterForm.value.workType[0] };
    }
    if (this.filterApplied) {
      this.data1.source = {
        myJobs: true,
        marketPlaceJobs: false,
        teamJobs: false,
        recruiterNetworkJobs: false,
        freeLancerNetworkJobs: false,
        mtaNetworkJobs: false,
        featured: false,
        suggestedJobs: false
      },
        this.data1.workType = { all: false, remoteWork: false, relocationRequired: false, workFromHome: false }
    }

    this.data1.searchAfterKey = null;

    this.data1.experienceFrom = this.jobFilterForm.value.experienceFrom;
    this.data1.experienceTo = this.jobFilterForm.value.experienceTo;
    this.data1.postedFrom = this.jobFilterForm.value.postedFrom;
    this.data1.postedTo = this.jobFilterForm.value.postedTo;
    this.data1.country = this.jobFilterForm.value.country;
    this.data1.state = this.jobFilterForm.value.state;
    this.data1.city = this.jobFilterForm.value.city;
    this.data1.zipCode = this.jobFilterForm.value.zipCode;
    this.data1.limit = 10;
    this.data1.userId = localStorage.getItem('userId');
    this.data1.jobClassification = jobClassificationUpdate;
    this.data1.clientType = clientTypeCheckboxesUpdate;
    this.data1.status = statusCheckboxesUpdate;
    this.data1.searchContent = this.searchContent;
    delete this.data1.searchContent;

    if (this.searchContent != "" && this.searchContent != undefined) {
      this.data1.searchContent = this.searchContent;
      this.data1.searchAfterKey = null;
    }

    if (this.jobSource.length != 0 && this.searchContent == "" || this.jobSource.length != 0 && this.searchContent == undefined) {
      this.data1.searchAfterKey = null
      localStorage.setItem('jobSource', JSON.stringify(this.jobSource));
      localStorage.setItem('jobForm', JSON.stringify(this.data1));
    } else if (this.searchContent != "" && this.searchContent != undefined) {
      this.data1.searchAfterKey = null
      localStorage.setItem('jobSource', JSON.stringify(this.jobSource));
      localStorage.setItem('jobForm', JSON.stringify(this.data1));
    }
    if (this.jobSource.length == 0) {
      this.data1.searchAfterKey = null
      localStorage.setItem('jobSource', JSON.stringify(this.jobSource));
      localStorage.setItem('jobForm', JSON.stringify(this.data1));
    }


  }

  statusCheckAll(event) {
    const checked = event.target.checked;
    this.statusCheckboxes.forEach(item => item.selected = checked);
  }

  removeEntity(value, index) {
    if (this.filterApplied != true) {
      this.jobSource.splice(index, 1);
      if (this.keyarrayjobsouces.includes(value)) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }
      if (this.keysarrWorks.includes(value)) {
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }

      this.clientTypeCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.clientTypeCheckboxes[0].selected = false
        }
      });

      this.statusCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.statusCheckboxes[0].selected = false
        }
      });

      this.jobclasscificationCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.jobclasscificationCheckboxes[0].selected = false
        }
      });

      if (value == 'myJobs') {
        // this.response = []
        this.obj.searchAfterKey = null;
        this.data1.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
      // this.applyFilternew();
    }

    // this.receiveFilterData.unsubscribe();

  }


  onMenuItemClick(event, param?: any): void {
    event.stopPropagation();

    if (param != null) {
      // this.meunTrigger.closeMenu();
    }
  }

  onCustomerSearch(e) {
    this.customerPayload.searchContent = e;
    this.setToDefaulFilter("CUSTOMER");
    this.getBusinessCustomers(this.memberAvailable ? "MEMBER_NETWORK" : "BUSINESS-NETWORK");
  }

  onCustomerScroll(e) {

    if(!this.customersStopScroll && JSON.stringify(this.customerPayload.searchAfterKey) != JSON.stringify(this.customersPrevSearchAfterKey)){
      this.customerPayload = {
        ...this.customerPayload,
        searchAfterKey: this.customersPrevSearchAfterKey
      }
       this.getBusinessCustomers(this.memberAvailable ? "MEMBER_NETWORK" : "BUSINESS-NETWORK", 'scroll');
    }
  }

  onPublishSearch(e) {
    this.publishedPayload.searchContent = e;
    this.setToDefaulFilter();
    this.getPublishedBy();
  }

  onPublishScroll(e) {
    if(!this.publishedByStopScroll && JSON.stringify(this.publishedPayload.searchAfterKey) != JSON.stringify(this.publishedByPrevSearchAfterKey)){
      this.publishedPayload = {
        ...this.publishedPayload,
        searchAfterKey: this.publishedByPrevSearchAfterKey
      }
      this.getPublishedBy();
    }
  }

  onEmployeeSearch(term: string) {
    this.employeeSearch.emit(term || "");
  }

  onEmployeeScroll(_: any) {
    this.employeeScroll.emit();
  }

  isSelectedField(c: keyof JobFilterVerticalTemplateComponent): boolean {
    return c === "selectedPublishedBy" || c === "selectedCustomers" || c === "selectedBusinessNetworks" || c === "selectedEmployees";
  }

  selectedPublishedBy = [];
  selectedCustomers = [];
  selectedBusinessNetworks = [];
  selectedEmployees: string[] = [];
  employeeList = new BehaviorSubject<any[]>([]);
  employeePrevSelectedValue: any[] = [];
  customerPrevSelectedValue = [];
  publishedByPrevSelectedValue = [];
  businessNetworkPrevSelectedValue = [];
  onSelectChange(data: any[], content) {

    // Clear the instant spinner the picker armed on tick. Selecting a
    // Customer / Published By value triggers no reload; the Business Network
    // branch below re-arms the GLOBAL overlay since a network pick reloads.
    this.isLoading = false;
    this.publishedByLoading = false;
    this.customerLoading = false;
    if (data && this.isSelectedField(content)) {

      const key =
        content === "selectedCustomers" ? "businessId" :
          content === "selectedBusinessNetworks" ? "b2bNetworkId" :
            content === "selectedEmployees" ? "userId" :
              "userId";

      this[content] = data.filter(x => x.enabled === true).map(c => c[key]);

      if (content === "selectedCustomers") {
        this.customerPrevSelectedValue = data.filter(x => x.enabled === true);
        this.customerPayload.businessList = this.selectedCustomers;
        const datas = this.customersList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.customersList.next(datas);

      }
      else if (content === "selectedPublishedBy") {
        this.publishedByPrevSelectedValue = data.filter(x => x.enabled === true);
        this.publishedPayload.users = this.selectedPublishedBy;
        const datas = this.publishedByList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.publishedByList.next(datas);
      }
      else if (content === "selectedEmployees") {
        this.employeePrevSelectedValue = data.filter(x => x.enabled === true);
        const datas = this.employeeList.getValue().sort((x, y) => (x.enabled === y.enabled) ? 0 : x.enabled ? -1 : 1);
        this.employeeList.next(datas);
      }
      else if (content === "selectedBusinessNetworks") {
        this.selectedBusinessNetworks = this.selectedBusinessNetworks.length === 0 ?
        this.allBusinessNetwork : this.selectedBusinessNetworks;
        this.setToDefaulFilter("CUSTOMER");
        this.customerPayload.businessNetworks = this.selectedBusinessNetworks;
        // A network pick reloads both lists → show the global panel overlay.
        this.isLoading = true;
        this.getBusinessCustomers("BUSINESS-NETWORK", 'global');
        this.businessNetworkPrevSelectedValue = data;
      }


      this.updateFunction();

      // if(content === "selectedBusinessNetworks"){
      //   this.setToDefaulFilter("CUSTOMER");
      //   this.customerPayload.businessNetworks = this.selectedBusinessNetworks.length === 0 ? this.businessNetworkData.map(x => x.b2bNetworkId) :
      //   this.selectedBusinessNetworks;
      //   this.getBusinessCustomers();
      // }
    }
  }

  onMemberNetworkScroll(e) {

  }

  onMemberNetworkSearch(e) {

  }

  onBusinessNetworkScroll(e) {

  }

  onBusinessNetworkSearch(e) {

  }

  getFormControlName(e) {
    let d = GigsumoService.FILTER_ITEMS().slice(0, 3);
    return d.find(x => x.value === e).key;
  }

  // Filter count methods for each section
  getBadgeClass(count: number): string {
    return count >= 10 ? 'filter-count-badge double-digit' : 'filter-count-badge';
  }

  // Job Source badge = ticked checkboxes only, same rules as the horizontal row
  // (job-filter-template.computeSourceCount): skip the "all" toggle, skip
  // "myEmployees" unless the SuperAdmin org view renders it, and skip the two
  // role/plan keys that are never a real user pick. Picker selections
  // (Published By / Business Networks / Customer) are NOT added here — each
  // picker shows its own sub-badge, and summing them inflated this number.
  getJobSourceCount(): number {
    const group = this.jobSourcesFormarray && this.jobSourcesFormarray.at(0) as FormGroup;
    if (!group) { return 0; }
    const userType = localStorage.getItem('userType');
    return Object.keys(group.controls).reduce((count, key) => {
      if (key === 'all') { return count; }
      if (key === 'myEmployees' && !this.orgJobsMode) { return count; }
      if (key === 'myJobs' && userType === GigsumoConstants.BENCH_RECRUITER) { return count; }
      if (key === 'businessNetwork' && (this.membershipType === 'Free' || this.membershipType === 'Pro')) { return count; }
      // Sub-Contracting checkbox is hidden for Job Seekers and Free plans (same
      // condition as its *ngIf), but the All toggle still patches it true.
      if (key === 'eligibleSubContractJobs'
        && (userType === GigsumoConstants.JOB_SEEKER || this.membershipType === 'Free')) { return count; }
      return count + (group.get(key)?.value === true ? 1 : 0);
    }, 0);
  }

  getClientTypeCount(): number {
    if (this.clientTypeCheckboxes && Array.isArray(this.clientTypeCheckboxes)) {
      return this.clientTypeCheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getJobClassificationCount(): number {
    if (this.jobclasscificationCheckboxes && Array.isArray(this.jobclasscificationCheckboxes)) {
      return this.jobclasscificationCheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getStatusCount(): number {
    if (this.statusCheckboxes && Array.isArray(this.statusCheckboxes)) {
      return this.statusCheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getLocationCount(): number {
    let count = 0;
    if (this.jobFilterForm) {
      const formValues = this.jobFilterForm.getRawValue();
      if (formValues.country && formValues.country !== 'null') count++;
      if (formValues.state && formValues.state !== 'null') count++;
      if (formValues.city && formValues.city !== 'null') count++;
      if (formValues.zipCode && formValues.zipCode !== 'null') count++;
    }
    return count;
  }

  getWorkModeCount(): number {
    if (this.workModeCheckboxes && Array.isArray(this.workModeCheckboxes)) {
      return this.workModeCheckboxes.filter(item => item.selected && item.label !== 'All').length;
    }
    return 0;
  }

  getTotalExperienceCount(): number {
    let count = 0;
    if (this.value > 0) count++;
    if (this.highValue > 0) count++;
    return count;
  }

  getPostedDaysCount(): number {
    if (this.jobFilterForm) {
      const postedDayRange = this.jobFilterForm.get('postedDayRange')?.value;
      return (postedDayRange && postedDayRange !== 'Any (Days)') ? 1 : 0;
    }
    return 0;
  }

  getPostedByCount(): number {
    let count = 0;
    if (this.jobFilterForm) {
      const formValues = this.jobFilterForm.getRawValue();
      if (formValues.owner) count++;
      if (formValues.systemsIntergrator) count++;
      if (formValues.primeVendor) count++;
      if (formValues.vendorStaffingAgency) count++;
    }
    return count;
  }

  // Methods for sub-section counts (similar to candidate component)
  getPublishedByCount(): number {
    if (this.selectedPublishedBy && Array.isArray(this.selectedPublishedBy)) {
      return this.selectedPublishedBy.length;
    }
    return 0;
  }

  getCustomerCount(): number {
    if (this.selectedCustomers && Array.isArray(this.selectedCustomers)) {
      return this.selectedCustomers.length;
    }
    return 0;
  }

  // Count the checked Business Networks. Reads businessNetworkData (the same
  // [filterData] source the checkboxes bind to) rather than
  // selectedBusinessNetworks, because onSelectChange overwrites the latter with
  // allBusinessNetwork when the user's picks reduce to empty (select-all
  // fallback) — counting `enabled` items always matches the visible checkboxes.
  getBusinessNetworkCount(): number {
    if (this.businessNetworkData && Array.isArray(this.businessNetworkData)) {
      return this.businessNetworkData.filter(x => x.enabled === true).length;
    }
    return 0;
  }

  getEmployeeCount(): number {
    if (this.selectedEmployees && Array.isArray(this.selectedEmployees)) {
      return this.selectedEmployees.length;
    }
    return 0;
  }

}
